<template>
  <div class="relative h-full lg:mt-0 -mt-4 bg-white rounded-t-xl flex flex-wrap">
    <nav-menu />

    <!-- Header -->
    <div class="w-full bg-gray-50 border-b border-gray-200">
      <div class="px-6 py-4">
        <div class="flex flex-wrap items-center gap-4">
          <h1 class="text-lg font-semibold text-gray-900 mr-4">Settings</h1>
        </div>
      </div>
    </div>

    <!-- Mobile tab bar -->
    <div class="lg:hidden w-full bg-white border-b border-gray-200 px-4 py-2">
      <div class="flex gap-2 overflow-x-auto no-scrollbar">
        <router-link
          v-for="item in navItems"
          :key="item.route"
          :to="{ name: item.route }"
          class="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors"
          :class="$route.name === item.route
            ? 'bg-primary text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
        >
          {{ item.label }}
          <i class="fa-solid fa-chevron-right text-[10px] opacity-60"></i>
        </router-link>
      </div>
    </div>

    <!-- Body -->
    <div class="h-full bg-gray-100 w-full">
      <div class="flex w-full">
        <!-- Desktop sidebar -->
        <aside class="hidden lg:block w-56 flex-shrink-0">
          <div class="sticky top-0 h-screen overflow-y-auto bg-white border-r border-gray-200 py-6">
            <nav class="space-y-1 px-3">
              <router-link
                v-for="item in navItems"
                :key="item.route"
                :to="{ name: item.route }"
                class="flex items-center justify-between px-4 py-3 rounded-lg text-base font-medium transition-colors group"
                :class="$route.name === item.route
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'"
              >
                <div class="text-left">
                  <span>{{ item.label }}</span>
                  <p class="text-xs font-normal mt-0.5" :class="$route.name === item.route ? 'text-gray-500' : 'text-gray-400'">{{ item.helper }}</p>
                </div>
                <i class="fa-solid fa-chevron-right text-xs opacity-40 group-hover:opacity-70 transition-opacity"></i>
              </router-link>
            </nav>
          </div>
        </aside>

        <!-- Content -->
        <div class="flex-1 min-w-0 p-4 lg:p-8">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from "@/components/headers/navMenu";

export default {
  components: {
    NavMenu,
  },
  data() {
    return {
      allNavItems: [
        { label: "SMS Templates", route: "SettingsSmsTemplates", helper: "Reusable message templates" },
        { label: "SMS Settings", route: "SettingsSmsConfig", helper: "Auto-reply messages" },
        { label: "Company Profile", route: "SettingsCompany", helper: "Business details" },
        { label: "Notifications", route: "SettingsNotifications", helper: "Alert preferences" },
        { label: "Tests", route: "SettingsTests", helper: "AI brief for test report matching" },
        { label: "Regions", route: "SettingsRegions", helper: "Map-based region boundaries" },
        { label: "Custom Fields", route: "SettingsCustomFields", helper: "Per-service job fields", adminOnly: true },
      ],
    };
  },
  computed: {
    // The router guard already blocks the route; this just keeps the dead link
    // out of the sidebar.
    navItems() {
      const isAdmin = this.$store.state.currentUser && this.$store.state.currentUser.role === "admin";
      return this.allNavItems.filter((i) => !i.adminOnly || isAdmin);
    },
  },
};
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
